import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { orderBy } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';
import { INVENTORY_TYPE, YEAR } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { getPagePublicationState } from 'site-modules/shared/utils/inventory/srp-utils';
import { PUB_STATES_LOWERCASE } from 'client/constants/pub-states';
import { getMakeModelLinkUrl, getMakeModelYearLinkUrl } from 'site-modules/shared/utils/vehicle-link-constructor';
import { isComboPageYear } from 'site-modules/shared/utils/inventory/srp-review-combo';
import { makeNiceName } from 'client/site-modules/shared/utils/nice-name';

function getLatestInventoriesYear({ inventory, selectedFacets }) {
  if (selectedFacets[YEAR] && selectedFacets[YEAR][0]?.split('-')[1] !== '*' && inventory.length) {
    const vehicle = orderBy(inventory, ['vehicleInfo.styleInfo.year'], ['desc'])[0];
    return vehicle.vehicleInfo?.styleInfo?.year;
  }

  return null;
}

export function ResearchPageLink({ vehicle = null, inventory = [], selectedFacets = {} }) {
  const { make = {}, model = {}, modelYear = {} } = vehicle ?? {};
  const { name: makeName, niceId: makeNiceId } = make;
  const { name: modelName, niceId: modelNiceId } = model;
  const { year: vehicleYear } = modelYear;

  const makeSlug = makeNiceId || makeNiceName(makeName);
  const modelSlug = modelNiceId || makeNiceName(modelName);

  if (!modelSlug) {
    return null;
  }

  const year = vehicleYear || getLatestInventoriesYear({ inventory, selectedFacets });
  const isUsedModel = getPagePublicationState(selectedFacets[INVENTORY_TYPE]) === PUB_STATES_LOWERCASE.USED;

  const link =
    isUsedModel && year
      ? getMakeModelYearLinkUrl({ makeSlug, modelSlug, year }, isComboPageYear(year) ? '' : `review/`)
      : getMakeModelLinkUrl({ makeSlug, modelSlug });

  const linkText = `${isUsedModel && year ? year : ''} ${makeName} ${modelName} Review`.trim();

  return (
    <div className={classNames('research-page-link size-16 text-gray-darker')}>
      <Link
        to={link}
        data-tracking-id="reviews_specs"
        data-tracking-value={`${year ? `${year} ` : ''}${makeName} ${modelName}`.trim()}
      >
        <span className="icon-arrow-left4 size-14 text-primary-darker" aria-hidden /> {linkText}
      </Link>
    </div>
  );
}

ResearchPageLink.propTypes = {
  vehicle: PropTypes.shape({}),
  inventory: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFacets: PropTypes.shape({}),
};
